import { render, staticRenderFns } from "./FieldAdd.vue?vue&type=template&id=2f4e029a"
import script from "./FieldAdd.vue?vue&type=script&lang=ts"
export * from "./FieldAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports